/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'kpi': {
    width: 26,
    height: 26,
    viewBox: '0 0 26 26',
    data: '<path pid="0" d="M11.69 26c-4.176 0-8.035-2.203-10.124-5.778a11.44 11.44 0 010-11.555C3.655 5.092 7.513 2.889 11.69 2.889a.98.98 0 01.69.282c.182.18.284.426.284.68v9.63h9.742a.98.98 0 01.689.282c.182.18.285.426.285.681 0 3.065-1.231 6.004-3.424 8.171A11.754 11.754 0 0111.69 26zm-.974-21.137A9.776 9.776 0 004.38 8.13a9.563 9.563 0 00-2.375 6.662 9.57 9.57 0 002.863 6.471 9.793 9.793 0 006.56 2.801 9.81 9.81 0 006.728-2.38 9.596 9.596 0 003.276-6.277H11.69a.968.968 0 01-.974-.963V4.863zm14.31 6.693h-9.741a.968.968 0 01-.975-.963V.963c0-.532.436-.963.975-.963 2.842 0 5.567 1.116 7.577 3.102A10.535 10.535 0 0126 10.592c0 .256-.102.501-.285.682a.98.98 0 01-.69.282zM16.259 9.63h7.734a8.627 8.627 0 00-2.513-5.162 8.808 8.808 0 00-5.221-2.484V9.63z" _fill="#27DBBD" fill-rule="evenodd"/>'
  }
})
